if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      }

      connectedCallback() {
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick.bind(this));
          tab.addEventListener('keydown', this.onKeyDown.bind(this));
        });
      }

      onTabClick(event) {
        const tab = event.currentTarget;
        this.selectTab(tab);
      }

      onKeyDown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let newIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            newIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            newIndex = 0;
            break;
          case 'End':
            newIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        const newTab = this.tabs[newIndex];
        newTab.focus();
        this.selectTab(newTab);
      }

      selectTab(tab) {
        const targetId = tab.getAttribute('aria-controls');
        const targetPanel = this.querySelector(`#${targetId}`);
        if (!targetPanel) return;

        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.setAttribute('tabindex', selected ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          if (panel === targetPanel) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }
    }
  );
}